export const environment = {
  production: false,
  apiBaseUrl: 'https://testapi.felix.no',
  vismaConnect: {
    authority: 'https://connect.identity.stagaws.visma.com',
    clientId: 'fenistra-felix',
    scope: 'openid profile email offline_access',
  },
};
